import { appBarLinks } from 'routes'
import { SectionLinks } from 'components'

export default function AppBarMenu() {
  return (
    <SectionLinks
      links={appBarLinks}
      className="justify-center flex-grow items-center"
      gutterBottom={false}
    />
  )
}
